export const getUrl = (protocol: "https" | "wss") => {
  const url = new URL(window.location.href);

  switch (process.env.NODE_ENV) {
    case "development": {
      url.protocol = "ws";
      url.pathname = "connect";
      break;
    }
    case "production": {
      url.protocol = protocol;
      url.pathname = "ws";
      break;
    }
    default:
      break;
  }

  return url;
};
